import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class CategoriesService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdCategories(categoryId): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'Categories/deleteCategories', {'categoryId': categoryId}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    countCategories(categories): Observable<number> {
        return this.httpClient.post<number>(Constant.BASE_URL + 'Categories/count', {'categories': categories}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    updateCategories(categories): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'Categories/updateCategories', [categories], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addCategories(categories): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'Categories/addCategories', [categories], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    findAllCategories(categories, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'Categories/findAllCategories',
            {'categories': categories, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}}, this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

}
